import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const HowItWorksContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    minHeight: "auto",
    gap: "24px",
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  borderRadius: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "50%",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    borderRadius: "20px",
    width: "100%",
    margin: "0 auto",
    overflow: "hidden",
  },

}));

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "50%",
  gap: "32px",
  [theme.breakpoints.down("md")]: {
    padding: "0 20px",
    justifyContent: "center",
    width: "100%",
    gap: "24px",
  },
}));

const StepContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "20px",
  [theme.breakpoints.down("md")]: {
    gap: "16px",
  },
}));

const StepNumber = styled(Box)(() => ({
  width: "45px",
  height: "45px",
  borderRadius: "50%",
  border: "1px solid var(--text-black)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  backgroundColor: "var(--background-white)",
}));

const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: "var(--text-black)",
  marginBottom: "8px",
  [theme.breakpoints.down("md")]: {
    fontSize: "36px",
    textAlign: "center",
    marginBottom: "0",
  },
}));

const StepNumberText = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  fontWeight: 500,
  color: "var(--text-black)",
}));

const StepText = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  color: "var(--text-black)",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
    maxWidth: "none",
  },
}));


const StyledImage = styled("img")(() => ({
  maxWidth: "100%",
  objectFit: "contain",
}));

export default function WhatIsImportantToKnow() {
  return (
    <HowItWorksContainer>
      <ImageContainer>
        <StyledImage src="/assets/Item.png" alt="GTC Pay App Interface" />
      </ImageContainer>

      <ContentContainer>
        <Title>Что важно знать</Title>

        <StepContainer>
          <StepNumber>
            <StepNumberText>1</StepNumberText>
          </StepNumber>
          <StepText>
            Данные клиентов — шифруются и хранятся в безопасных дата-центрах
          </StepText>
        </StepContainer>

        <StepContainer>
          <StepNumber>
            <StepNumberText>2</StepNumberText>
          </StepNumber>
          <StepText>
            Полный KYC/KYB — через аккредитованного провайдера (Sum&Substance).
          </StepText>
        </StepContainer>

        <StepContainer>
          <StepNumber>
            <StepNumberText>3</StepNumberText>
          </StepNumber>
          <StepText>
            Отчётность — ежедневная выгрузка транзакций, санк-чеков и лимитов.
          </StepText>
        </StepContainer>

        <StepContainer>
          <StepNumber>
            <StepNumberText>4</StepNumberText>
          </StepNumber>
          <StepText>Лицензии и реквизиты — доступны по запросу.</StepText>
        </StepContainer>
      </ContentContainer>
    </HowItWorksContainer>
  );
}
